import { Action } from 'helpers/action-helpers';
import { LoginType } from 'types/login-type';

export const LOGIN_ACTION = 'LoginAction';
export const LOGOUT_ACTION = 'LogoutAction';
export const REFRESH_TOKEN_ACTION = 'RefreshTokenAction';
export const USER_LOGGED_IN_ACTION = 'UserLoggedInAction';
export const SET_USER_PERMISSIONS_ACTION = 'SetUserPermissionsAction';
export const LOGIN_ERROR_ACTION = 'LoginErrorAction';
export const SWITCH_TO_BARCODE_LOGIN_ACTION = 'SwitchToBarcodeLoginAction';
export const SWITCH_TO_USERNAME_LOGIN_ACTION = 'SwitchToUsernameLoginAction ';
export const GET_PERMISSIONS = 'GetPermissionsAction';
export const BEGIN_LOGIN_ACTION = 'BeginLoginAction';

export class LoginAction extends Action {
  constructor(
    public loginType: LoginType,
    public usernameOrBarcode: string,
    public passwordOrPin: string
  ) {
    super(LOGIN_ACTION);
  }
}

export class LogoutAction extends Action {
  constructor(public reason: string) {
    super(LOGOUT_ACTION);
  }
}

export class RefreshTokenAction extends Action {
  constructor() {
    super(REFRESH_TOKEN_ACTION);
  }
}

// only to be used on a page refresh
export class SetUserPermissionsAction extends Action {
  constructor(public permissions: string) {
    super(SET_USER_PERMISSIONS_ACTION);
  }
}

export class UserLoggedInAction extends Action {
  constructor(public permissions: string) {
    super(USER_LOGGED_IN_ACTION);
  }
}

export class LoginErrorAction extends Action {
  constructor(public loginErrorMessage: string) {
    super(LOGIN_ERROR_ACTION);
  }
}

export class SwitchToBarcodeLoginAction extends Action {
  constructor(public epc: string) {
    super(SWITCH_TO_BARCODE_LOGIN_ACTION);
  }
}

export class SwitchToUsernameLoginAction extends Action {
  constructor(public username: string) {
    super(SWITCH_TO_USERNAME_LOGIN_ACTION);
  }
}

export class BeginLoginAction extends Action {
  constructor() {
    super(BEGIN_LOGIN_ACTION);
  }
}


// WEBPACK FOOTER //
// ./src/pages/login/actions.ts